import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Modal,
} from '@chakra-ui/react';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const MenuCategoryDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteMenuCategory,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">カテゴリーの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>カテゴリーID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>カテゴリー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のカテゴリー情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteMenuCategory} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
